interface IEnumObject { value: number; key: string; }

export default class {
    // tslint:disable-next-line:array-type
    public static enumToArray(E: any): IEnumObject[] {
        const result = [];
        const keys = Object.keys(E).filter(k => typeof E[k as any] === "number"); // ["A", "B"]
        const values = keys.map(k => E[k as any]);
        for (const v of values) {
            result.push({ value: v, key: E[v] })
        }
        return result
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/Enums.ts